import { render, staticRenderFns } from "./Tareas.vue?vue&type=template&id=180d27fe&scoped=true&"
import script from "./Tareas.vue?vue&type=script&lang=js&"
export * from "./Tareas.vue?vue&type=script&lang=js&"
import style0 from "./Tareas.vue?vue&type=style&index=0&id=180d27fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180d27fe",
  null
  
)

export default component.exports